import React from "react";
import AuthLabeledTextInput from "./AuthLabeledTextInput";
import { phoneNumber } from "@mysnowscape/snow-lib";

function PhoneNumberInput({
  setValue,
  name = "phone",
  label = "Mobile Phone Number",
  placeholder = "712 555 0100",
  testId,
  className,
  value,
  required,
  defaultValue,
  autoFocus,
  showValidation,
  disabled,
}) {
  return (
    <>
      <AuthLabeledTextInput
        label={label}
        name={name}
        maxLength={12}
        placeholder={placeholder}
        inputMode="tel"
        pattern="(\+1[0-9]{10}|[0-9]{10})"
        required={required}
        defaultValue={defaultValue}
        value={value}
        setValue={setValue}
        autoFocus={autoFocus}
        disabled={disabled}
        className={className}
        testId={testId}
        showValidation={showValidation}
        onInput={(e) => {
          let target = e.nativeEvent.target;
          if (!target.value.startsWith("+1") && target.value.length > 10) {
            target.value = target.value.slice(0, 10);
          }
          if (target.validity.patternMismatch) {
            target.setCustomValidity(
              "Please enter a US or Canadian phone number with area code. i.e. 712 555 0100",
            );
          } else {
            target.setCustomValidity("");
          }
        }}
      />
    </>
  );
}
function normalizePhoneNumberValue(value) {
  return phoneNumber.normalizePhoneNumberValue(value);
}
export default PhoneNumberInput;
export { normalizePhoneNumberValue };
